import { render, staticRenderFns } from "./characterAdd.vue?vue&type=template&id=43a7c1b6&scoped=true&"
import script from "./characterAdd.vue?vue&type=script&lang=js&"
export * from "./characterAdd.vue?vue&type=script&lang=js&"
import style0 from "./characterAdd.vue?vue&type=style&index=0&id=43a7c1b6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43a7c1b6",
  null
  
)

export default component.exports